module.exports = __webpack_public_path__ + "img/fd05805d91f078e9afecb4bd7c775e69.svg";